import React from "react";
import { LogoText } from "./LogoText";
import { ThemeToggle } from "./ThemeToggle";
import { Theme } from "../constants/colors";

interface HeaderProps {
  theme: Theme;
  onToggleTheme: () => void;
  hidden?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  theme,
  onToggleTheme,
  hidden = false,
}) => {
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-6 py-4 transition-all duration-400 ${
        hidden ? "opacity-0 pointer-events-none" : "opacity-100"
      } bg-gradient-to-b from-warmWhite dark:from-darkBg to-transparent dark:to-transparent backdrop-blur-sm`}
    >
      <LogoText className="text-deepCharcoal dark:text-darkText font-light tracking-wider" />
      <ThemeToggle theme={theme} onToggle={onToggleTheme} />
    </header>
  );
};
